import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Typography } from '../index'
import styles from './badge.module.scss'
import colors from '../variables/colors'

const Badge = ({
  startIcon = null,
  color = 'inherit',
  bgColor = 'Background-Quaternary',
  className = '',
  children = null,
  component: WrapperComponent = 'div',
  noWrap = false,
  ...rest
}) => (
  <WrapperComponent
    className={clsx(styles['badge'], className, {
      [styles['badge_nowrap']]: noWrap,
    })}
    style={{ backgroundColor: `var(--color-${bgColor})` }}
    {...rest}
  >
    {startIcon}
    <Typography
      color={color}
      variant={'Body-15'}
      className={styles['badge__label']}
    >
      {children}
    </Typography>
  </WrapperComponent>
)

Badge.propTypes = {
  className: PropTypes.string,
  startIcon: PropTypes.element,
  color: PropTypes.oneOf(colors),
  bgColor: PropTypes.oneOf(colors),
  component: PropTypes.elementType,
  children: PropTypes.elementType,
  noWrap: PropTypes.bool,
}

export default Badge
